module.exports = __webpack_public_path__ + "img/cateicon0.c0efe3ad.svg";